import parts from './parts'
import slash from './slash'
import tools from './tools'

export default [slash, parts, tools]
